import _ from 'underscore';
import { logProgramChange } from '@shoflo/studio-redux/utils';
import { sceneBuilder, selectSceneLayout } from '@studio/program';
import {
  updateSource,
  setProgram,
  cancelDisconnectSource,
  dismissAttendee,
  setSceneLayout
} from 'actions/Broadcast';
import { BROADCAST_DISCONNECT_SOURCE } from 'actions/Types';
import {
  UNASSIGNED,
  getProgramLayers,
  attachAudioPresenterSources
} from 'utils/broadcastSourceHelper';
import { getBroadcastSourcesFromLayers } from '../utils';

export default sourceId => {
  return (dispatch, getState) => {
    const {
      sceneLayout,
      sceneLayers,
      banners,
      attendeeMuteStatus,
      broadcastSources,
      program,
      brandingSettings
    } = getState();

    const layers = getProgramLayers(program);

    // set source to unassigned after 120sec
    const timeoutId = setTimeout(() => {
      dispatch(updateSource(sourceId, { value: UNASSIGNED }));
      dispatch(cancelDisconnectSource(sourceId));
      dispatch(dismissAttendee(sourceId));
    }, 120 * 1000);

    // Get layer source
    const [layerSource] = layers?.filter(
      layer => layer?.source._id === sourceId
    );

    // If disconnected source exist in program, rebuild scene
    if (!!layerSource) {
      const sourcesInProgram = getBroadcastSourcesFromLayers(
        layers,
        broadcastSources?.sources
      );

      const nextSceneLayout = selectSceneLayout(
        sceneLayout,
        layerSource.source,
        sourcesInProgram
      );

      const combinedLayers = [...sceneLayers, ...banners];

      const sources = layers
        .map(layer => layer.source)
        // Need to make sure the source is in the broadcastSources array, otherwise we'd include overlays or other source here
        .filter(source =>
          _.find(broadcastSources.sources, bs => bs._id === source._id)
        )
        .filter(source => source._id !== sourceId);

      const withAudioPresenterSources = attachAudioPresenterSources(
        sources,
        attendeeMuteStatus
      );

      const scene = sceneBuilder(
        nextSceneLayout,
        withAudioPresenterSources,
        combinedLayers,
        {},
        {},
        brandingSettings?.fonts
      );

      dispatch(setProgram(scene));
      logProgramChange(getState, 'disconnectSource action');

      if (!_.isEqual(sceneLayout, nextSceneLayout)) {
        dispatch(setSceneLayout(nextSceneLayout));
      }
    }

    const action = {
      type: BROADCAST_DISCONNECT_SOURCE,
      payload: { sourceId, timeoutId }
    };

    dispatch(action);

    dispatch(updateSource(sourceId, { hidden: true }));
  };
};
